import numeral from 'numeral';
import { getCurrencySymbol } from './currency';

// ----------------------------------------------------------------------

type InputValue = string | number | null;

export function fNumber(number: InputValue, decimals = 2) {
  let str = '';
  for (let i = 0; i < decimals; i++) str += '0';
  return numeral(number).format('0,0.' + str);
}

export function fCurrency(number: InputValue) {
  const format = number ? numeral(number).format('£0,0.00') : '';

  return result(format, '.00');
}

export function fPercent(number: InputValue) {
  const format = number ? numeral(Number(number) / 100).format('0.00%') : '';

  return result(format, '.00');
}

export function fShortenNumber(number: InputValue) {
  const format = number ? numeral(number).format('0,0.00') : '';

  return result(format, '.00');
}

export function fData(number: InputValue) {
  const format = number ? numeral(number).format('0.0 b') : '';

  return result(format, '.0');
}

function result(format: string, key = '.00') {
  const isInteger = format.includes(key);

  return isInteger ? format.replace(key, '') : format;
}

export const bytesToMB = (bytes: number) => {
  const mb = bytes / (1024 * 1024);
  return mb.toFixed(4);
};

export const formatAmount = (amount: string | number, currency?: string) => {
  const numeric = typeof amount === 'number' ? amount : Number(String(amount ?? '').replace(/[^0-9.-]/g, ''));
  const formatted = new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(Number.isFinite(numeric) ? numeric : 0);

  return `${getCurrencySymbol(currency ?? 'GBP')}${formatted}`;
};
